import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { EmailCampaign, EmailCampaignService } from '../services/email-campaign.service';

@Component({
  selector: 'app-admin-email-campaigns',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    NzCardModule,
    NzButtonModule,
    NzInputModule,
    NzSelectModule,
    NzTableModule,
    NzTagModule,
  ],
  templateUrl: './admin-email-campaigns.component.html',
  styleUrl: './admin-email-campaigns.component.less',
})
export class AdminEmailCampaignsComponent implements OnInit {
  campaigns: EmailCampaign[] = [];
  loading = false;
  search = '';
  statusFilter = '';

  constructor(
    private service: EmailCampaignService,
    private message: NzMessageService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.listCampaigns({ search: this.search, status: this.statusFilter || undefined }).subscribe({
      next: (rows) => {
        this.campaigns = rows || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.message.error(this.translate.instant('ADMIN.EMAIL_CAMPAIGNS.MSG_LOAD_LIST_FAILED'));
      },
    });
  }

  createNew(): void {
    this.router.navigateByUrl('/admin/email-campaigns/new');
  }

  edit(item: EmailCampaign): void {
    this.router.navigateByUrl(`/admin/email-campaigns/${item._id}`);
  }

  openHistory(item: EmailCampaign): void {
    this.router.navigateByUrl(`/admin/email-campaigns/${item._id}`);
  }

  statusColor(status: string): string {
    if (status === 'sent') return 'green';
    if (status === 'sending') return 'blue';
    if (status === 'failed') return 'red';
    if (status === 'ready') return 'gold';
    return 'default';
  }
}

